import { getByType } from 'utils/stuff.js'
import * as R from 'ramda'
import { leases, tenants } from './entities'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { propertiesEx } from './properties'


export let propertiesExtended = createSelector(
	[leases, tenants, propertiesEx]
  , (leases, tenants, properties) => R.map(
		exProp(leases, tenants)
	  , properties
	)
)


let exProp = (leases, tenants) => (property) => ({
	...property
  , tenant: (
		leases[property.leaseID]
		&& leases[property.leaseID].tenantsIDs
		&& leases[property.leaseID].tenantsIDs[0]
		&& leases[property.leaseID].tenantsIDs[0].length
		&& tenants[leases[property.leaseID].tenantsIDs[0]]
	)?
  		tenants[leases[property.leaseID].tenantsIDs[0]]._id
	: undefined
})



// WEBPACK FOOTER //
// ./src/selectors/newProject.js